/*
 * @Author: Dom
 * @Date: 2022-07-07 10:43:11
 * @LastEditTime: 2022-08-03 10:35:07
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\store\useraddress.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { getUserAddressList, getStationList } from '@/services/useraddress';
import { UserAddressParamsType, UserAddressListResType, StationResType } from '@/services/data.d';

export interface StateType {
    errorMsg?: string;
    list: UserAddressListResType;
    sinfo: StationResType
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getList: Mutation<StateType>;
        getsList: Mutation<StateType>;
    },
    actions: {
        getUserAddressListFn: Action<StateType,StateType>;
        getStationListFn: Action<StateType,StateType>;
    }
}

const initState: StateType = {
    errorMsg: undefined,
    list: {
        ulist:[]
    },
    sinfo: {
        slist: []
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'useraddress',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getList(state,payload){
            state.list.ulist = payload
        },
        getsList(state,payload){
            state.sinfo.slist = payload
        }
    },
    actions: {
        async getUserAddressListFn({ commit }, params:UserAddressParamsType){
            let msg: string | undefined = undefined
            try{
                const {body} = await getUserAddressList(params)
                let list:any = []
                body.forEach((item:any, index:number) => {
                    list.push({
                        id: index,
                        addressName: item.addressName,
                        detailedAddress: item.detailedAddress,
                        addressCode: item.addressCode,
                        province: item.province,
                        city: item.city,
                        region: item.region
                    })
                })
                commit('getList',list)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        async getStationListFn({ commit }, params:any){
            let msg: string | undefined = undefined
            try{
                const {body} = await getStationList(params)
                console.log('body',body);
                commit('getsList',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel
